module.exports = __webpack_public_path__ + "img/pg.9b228e6.svg";